import React from 'react'

import injectStyle from 'utils/client/injectStyle'

export default function useLoqateSearch({ alpha2Code, batch, change }) {
  const [searchOptions] = React.useState(() => ({
    key: 'DZ54-YU92-BC38-BN81',
    countries: {
      codesList: alpha2Code,
    },
    setCountryByIP: false,
  }))
  const [loaded, setLoaded] = React.useState(false)
  const pca = React.useRef(null)

  React.useEffect(() => {
    const script = document.getElementById('loqate-script')

    const initLoqate = () => {
      setLoaded(true)
      pca.current = window.pca
    }

    if (script) {
      initLoqate()
    } else {
      injectStyle(
        'https://services.postcodeanywhere.co.uk/css/address-3.91.css',
        'loqate-styles',
      )

      const loqateScript = document.createElement('script')

      loqateScript.setAttribute('type', 'text/javascript')
      loqateScript.setAttribute('async', '')
      loqateScript.setAttribute('defer', '')
      loqateScript.setAttribute(
        'src',
        'https://services.postcodeanywhere.co.uk/js/address-3.91.js',
      )
      loqateScript.id = 'loqate-script'
      loqateScript.onload = initLoqate

      document.head.appendChild(loqateScript)
    }
  }, [])

  React.useEffect(() => {
    if (loaded && pca.current) {
      const fields = [{ element: 'find-address', field: 'PostalCode' }]
      const control = new pca.current.Address(fields, searchOptions)

      control.listen('populate', function(address) {
        const full_address = `${address.Line1} ${address.City} ${address.PostalCode}`
        batch(() => {
          change('find-address', full_address)
          change('postcode', address.PostalCode)
          change('address', address.Line1)
          change('address2', address.Line2)
          change('address3', address.Line3)
          change('region', address.Province)
          change('city', address.City)
        })
      })
    }
  }, [searchOptions, loaded, batch, change])
}
